import type { MissingImagePackage } from '../../../services/adminUnits';
import { formatMoment } from './unitsFormat';

function PackageCard({ item }: { item: MissingImagePackage }) {
  return (
    <div className="card" role="listitem" style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <span className="mono" style={{ fontWeight: 600, fontSize: 13.5 }}>
          {item.packageId} {item.packageVersion}
        </span>
        {item.kind === 'NewVersion' ? (
          <span className="chip warn"><span className="dot" />New version</span>
        ) : (
          <span className="chip accent"><span className="dot" />New package</span>
        )}
      </div>
      {item.kind === 'NewVersion' && (
        <div style={{ fontSize: 13 }}>
          The image has <span className="mono">{item.bakedVersions.join(', ')}</span>
        </div>
      )}
      <div className="muted" style={{ fontSize: 12.5 }}>
        Engine version {item.engineVersion} · image <span className="mono">{item.imageTag}</span> · found by{' '}
        {item.timesSeen} {item.timesSeen === 1 ? 'worker' : 'workers'} · first seen {formatMoment(item.firstSeenAt)} ·
        last seen {formatMoment(item.lastSeenAt)}
      </div>
    </div>
  );
}

export default function MissingPackagesList({ packages }: { packages: MissingImagePackage[] }) {
  if (packages.length === 0) {
    return (
      <div className="card quiet" style={{ padding: 20 }}>
        <span className="muted">No job brought a package the image lacks.</span>
      </div>
    );
  }
  return (
    <div role="list" aria-label="Missing packages" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {packages.map((item) => (
        <PackageCard key={`${item.packageId}/${item.packageVersion}/${item.imageTag}`} item={item} />
      ))}
    </div>
  );
}
